/*
 * Copyright (c) 2023 Trimble Inc. All rights reserved.
 */

import { Button } from '@mui/material';
import * as React from 'react';
import Dropzone from 'react-dropzone';
import './styles.css';
interface Props {
    selectedPdf: any
    UpdateSelectedPdf: Function
}
interface State {
    error: any
}
class DragDropConstants extends React.Component<Props, State>{
    state = {
        error: undefined,
    };
    checkSizeAndNumberOfFiles = (files: any, fileSize: any) => {
        if (files.length > 0 && files.length <= 1000) {
            if (fileSize <= 150000000) {
                this.props.UpdateSelectedPdf(files);
            }
            else {
                this.setState({ error: 'Size of files is more than 150000000 bytes' });
            }
        }
        else {
            this.setState({ error: 'Only 1000 files can be uploaded' });
        }
    };
    onDrop = (files: any) => {
        this.setState({ error: undefined });
        const uniqueFiles: any[] = [];
        let fileSize = 0;
        if (this.props.selectedPdf !== undefined) {
            let selectedPdf = this.props.selectedPdf;
            selectedPdf = selectedPdf.concat(files);
            selectedPdf.map((item: any) => {
                const findItem = uniqueFiles.find((x: any) => x.name === item.name);
                if (!findItem) {
                    uniqueFiles.push(item);
                }
                else { uniqueFiles[uniqueFiles.indexOf(findItem)] = findItem; }
            });
            uniqueFiles.forEach((file: any) => {
                fileSize = fileSize + file.size;
            });
            this.checkSizeAndNumberOfFiles(uniqueFiles, fileSize);
        }
        else {
            files.map((item: any) => {
                const findItem = uniqueFiles.find((x: any) => x.name === item.name);
                if (!findItem) {
                    uniqueFiles.push(item);
                }
            });
            uniqueFiles.forEach((file: any) => {
                fileSize = fileSize + file.size;
            });
            this.checkSizeAndNumberOfFiles(uniqueFiles, fileSize);
        }
    };

    onDropRejected = (error: any) => {
        const errorMessage = error[0].errors[0].message;
        this.setState({ error: errorMessage });
    };

    render() {
        const { error } = this.state;
        return (
            (this.props.selectedPdf === undefined) ?
                <div className="text-center dropZone">
                    <p className="redColor">{error}</p>
                    <Dropzone onDrop={this.onDrop} accept={{ 'application/zip': ['.zip'], 'text/plain': ['.txt'] }}
                        onDropRejected={this.onDropRejected} >
                        {({ getRootProps, getInputProps }) => (
                            <div {...getRootProps()}>
                                <input {...getInputProps()} />
                                {(this.props.selectedPdf === undefined) ?
                                    <div>
                                        <p> Drag & Drop file here </p>
                                        <p>(or)</p>
                                        <Button className="uploadFromComputer">Upload from computer</Button>
                                    </div>
                                    :
                                    <div>
                                        <p> {this.props.selectedPdf.length > 0 && `${this.props.selectedPdf[0].name} and ${this.props.selectedPdf.length - 1} files`} </p>
                                    </div>
                                }
                            </div>
                        )}
                    </Dropzone>
                </div>
                :
                <div className="text-center dropZone">
                    <p className="redColor">{error}</p>
                    <Dropzone onDrop={this.onDrop} accept={{ 'application/zip': ['.zip'], 'text/plain': ['.txt'] }}
                        onDropRejected={this.onDropRejected}>
                        {({ getRootProps, getInputProps }) => (
                            <div {...getRootProps()}>
                                <input {...getInputProps()} />

                                <div>
                                    <p> {(this.props.selectedPdf.length === 1) ?
                                        `${this.props.selectedPdf[0].name}` : `${this.props.selectedPdf[0].name} and ${this.props.selectedPdf.length - 1} files`} </p>
                                </div>
                            </div>
                        )}
                    </Dropzone>
                </div>
        );
    }
}

export default DragDropConstants;
